let toastQueue = [];
let isShowingToast = false;

function showToast(text) {
	toastQueue.push(text);
	processToastQueue();
}

function processToastQueue() {
	if (isShowingToast || toastQueue.length === 0) {
		return;
	}

	isShowingToast = true;
	const text = toastQueue.shift();

	const toastBody = document.createElement("div");
	toastBody.classList.add('fac-toast');

	// 添加使元素显示在最上层的样式
	toastBody.style.maxWidth = "80%";
	toastBody.style.position = "fixed";
	toastBody.style.zIndex = "10000";
	toastBody.style.left = "50%";
	toastBody.style.bottom = "30px";
	toastBody.style.transform = "translateX(-50%)";

	toastBody.innerText = text;
	document.body.append(toastBody);

	const timeoutID = window.setTimeout(() => {
		document.body.removeChild(toastBody);
		window.clearTimeout(timeoutID);
		isShowingToast = false;
		processToastQueue(); // 显示下一个toast
	}, 3000);
}

export {
	showToast
}